import React, { CSSProperties, useCallback } from 'react'
import styled, { css } from 'styled-components/macro'
import { fieldBase } from '../Form'
import checkImg from './check.svg'

export interface InputProps extends fieldBase<boolean> {
  style?: CSSProperties
  selected?: boolean
  onClick?: (e: MouseEvent) => void
  color?: string
}

const Check = styled.div<{
  selected: boolean
  readOnly?: boolean
  color?: string
}>`
  border-radius: 6px;
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
  ${(props) =>
    props.selected
      ? css`
          border: 2px solid transparent;
          background-color: ${props.color ? props.color : '#12b7e7'};
          background-image: url(${checkImg});
          background-position: center;
        `
      : css`
          border: 2px solid rgba(9, 21, 38, 0.6);
          background: #ffffff;
        `}
  ${(props) => props.readOnly && `border: 2px solid transparent;`}
`
const Input = styled.input`
  display: none;
`
const Label = styled.label`
  display: flex;
`
const Text = styled.div`
  margin-left: 8px;
  font-size: 16px;
  line-height: 22px;
`
function Checkbox(props: React.PropsWithChildren<InputProps>) {
  const handleChange = useCallback(() => {
    if (props.readOnly) return
    props.onChange?.(!props.value)
  }, [props.onChange, props.value, props.readOnly])

  const selectedControl = props.value || false
  return (
    <Label>
      <Input
        type="checkbox"
        onChange={handleChange}
        checked={selectedControl}
        onSelect={handleChange}
      />
      <Check
        readOnly={props.readOnly}
        selected={selectedControl}
        color={props.color}
      />
      <Text>{props.children}</Text>
    </Label>
  )
}

export default Checkbox
